export type Cents = number;
export type Dollars = number;
export type FormattedDollars = string;

export const DEFAULT_VALUE_PLACEHOLDER = '--';
